<template>
  <header class="app-header flex align-center ignore-theme-style_" v-if="showHeader">
    <div class="container header-content width-all flex align-center space-between height-all" :class="{[$route.matched.find(c => c.name === 'MainSidebarView') || true ? 'full-screen-container' : 'container'] : true}">
      <router-link v-if="(!isUserWatchOnly || !selectedOrgId || isSingleOrgMode) && orgId" :to="{name: 'ReleasePage', params: {organizationId: orgId} }" class="height-all">
        <div class="logo-title height-all flex align-center justify-center_" :class="{'centered-logo': (orgId != '-1') && (orgLogo || true) && isScreenWide }">
          <img v-if="showLogo" class="actual" :src="logoImgSrc" alt=""/>
        </div>
      </router-link>
      <FormInput v-else class="org-selector" v-model="selectedOrgId" :reactive="true" @change="setOrg" type="select" :items="organizationsToSelect"/>
      
      <template v-if="headerMode === 'default'">
        <NavOrBurger class="release-actions align-center_ space-between flex gap10 height-all" side="left" v-if="showNavContent" :class="{'flex-1': isScreenWide}">
          <LoggedUserPreview v-if="isUserWatchOnly" class="to-the-right nav-item small-screen-item"/>
          <div class="links create-links nav-items flex align-center gap20 height-all" v-if="isOrgProducer">
            <template v-for="type in organization.releaseTypes">
              <router-link
                v-if="orgId"
                :key="type.id"
                class="nav-item create-nav create-nav-link gap15"
                :to="{ name: 'ReleaseEdit', params: {organizationId: orgId}, query: {releaseType: type.id} }"
              >
                <span class="create-nav-link-inner hover-pop">
                  <span class="create-nav-plus svg-parrent" aria-hidden="true" v-html="plusIconHtml"></span>
                  {{$t('create')}} {{type.name}}
                </span>
              </router-link>
            </template>
          </div>

          <div class="nav-items flex align-center gap30 wrap height-all flex-1 justify-end">
            <!-- Wrap: flex-basis 0 so this column shrinks with row; form inside width 100% = box follows wrap width -->
            <div
              v-if="isScreenWide && ($route.name === 'ReleasePage')"
              class="header-search-wrap"
            >
            <form
              class="header-search-form flex justify-end align-center"
              @submit.prevent="onSearchSubmit"
            >
              <div class="header-search-box" dir="ltr">
                <span class="header-search-icon svg-parrent" aria-hidden="true" v-html="searchIconHtml"></span>
                <input
                  v-model="searchTerm"
                  type="text"
                  class="header-search-input"
                  :placeholder="$t('search')"
                  @keydown.enter.prevent="onSearchSubmit"
                />
                <button
                  v-show="searchTerm"
                  type="button"
                  class="header-search-clear"
                  aria-label="Clear"
                  @click="clearSearch"
                >
                  ×
                </button>
              </div>
            </form>
            </div>
            <div class="filters nav-items flex align-center_ height-all">
              <!-- <button :class="{selected: selecterOrgFilterId === filter.id}" v-for="filter in organization.routes" :key="filter._id" @click="emitFilter(filter)">
                {{filter.title}}
              </button> -->
              <router-link
                v-for="filterItem in filteredRoutesByRoles" :key="filterItem.id"
                :to="{ name: 'ReleasePage', params: { organizationId: orgId }, query: { page: filterItem.name  } }"
                class="nav-item flex align-center height-all"
                :class="{selected: $route.query.page === filterItem.name}"
                v-if="orgId"
              >
                <span class="hover-pop">{{filterItem.name}}</span>
              </router-link>
            </div>
          </div>
          <template v-if="isUserWatchOnly">
            <button class="nav-item logout-btn" @click="logout">{{$t('authLocales.logout')}}</button>
            <router-link class="nav-item edit-btn" :to="{ name: 'AccountEditModal', params: { id: loggedUser._id } }">{{$t('authLocales.editUserDetails')}}</router-link>
            <router-link class="nav-item org-header flex align-center gap10 small-screen-item" :to="{name: 'SettingsPage', params: {organizationId: orgId} }">
              <img :src="require('@/assets/images/icons/settings.png')" class="icon" alt=""/>
            </router-link>
          </template>
          <!-- <div class="release-actions nav flex align-center gap50 height-all" :class="{show:mobileShow}" v-if="showNavContent">
          </div> -->
        </NavOrBurger>

        <div class="flex align-center gap20 height-all wide-screen-item" v-if="isUserWatchOnly">
          <template>
            <router-link class="nav-list-item org-header flex align-center gap10" :to="{name: 'SettingsPage', params: {organizationId: orgId}}">
              <!-- <p>{{$t('settingsLocales.settings')}}</p> -->
              <img :src="require('@/assets/images/icons/settings.png')" class="icon" alt=""/>
            </router-link>
            <LoggedUserPreview class="to-the-right"/>
          </template>
          <!-- <div class="release-title height-all">
            <div class="actual height-all flex-center">
              <h2>Megaphon</h2>
            </div>
          </div> -->
        </div>
        <!-- <div v-else class="ph wide-screen-item"></div> -->
      </template>

      <!-- <template v-if="headerMode === 'ReleaseEdit'">
        <div class="flex gap10 align-center space-between container height-all">
          <div>
            <button class="underline btn__ big" v-if="itemToEdit._id" @click="deleteItem">{{$t('delete')}}</button>
          </div>
          <div class="flex align-center gap30 height-all">
            <button class="btn big" @click="close">{{$t('close')}}</button>
            <button class="btn big ignor-flex flex align-center gap15" :disabled="!itemToEdit._id" @click="showDesign = true" ><div v-html="megSvgs.PreviewActions.eye" class="svg-parrent"></div><span>{{$t('releaseLocales.designAndPreview')}}</span></button>
            <button class="btn big ignor-flex flex align-center gap15" :disabled="!isItemValid" @click="saveItem"><div v-html="megSvgs.save" class="svg-parrent"></div><span>{{$t('save')}}</span></button>
            <button class="btn big bg-4 clr-1 ignor-flex flex align-center gap15" :disabled="!isItemValid" @click="confirmAndDistribute"><div v-html="megSvgs.PreviewActions.distribute" class="svg-parrent"></div><span>{{$t('distributeLocales.distribute')}}</span></button>
          </div>
        </div>
      </template> -->
    </div>
  </header>
</template>

<script> 
import Avatar from '@/apps/common/modules/common/cmps/Avatar.vue';
import { organizationService } from '../../organization/services/organization.service';
import LoggedUserPreview from '../../../../common/modules/auth/cmps/LoggedUserPreview.vue';
import FormInput from '../../../../common/modules/common/cmps/FormInput.vue';
import NavOrBurger from '../../../../common/modules/common/cmps/NavOrBurger.vue';
import appConfig from '@/appConfig';
import { fixFileSrcToThumbnail } from '../../../../common/modules/common/services/file.service';
import  { getSvgs as getGlobalSvgs } from '@/assets/images/svgs.js';
import  { getMegSvgs } from '../../../assets/images/svgs';
import evManager from '@/apps/common/modules/common/services/event-emmiter.service.js';
export default {
  name: 'AppHeader',
  data() {
    return {
      // selecterOrgFilterId: null,
      selectedOrgId: this.$route.params.organizationId || '',
      showLogo: true,
      searchTerm: '',
      evManager
    }
  },
  computed: {
    showHeader() {
      return !this.$route.matched.find(c => c.name === 'AuthApp');
    },
    isScreenWide() {
      return this.$store.getters.isScreenWide;
    },
    isSingleOrgMode() {
      return appConfig.singleOrgMode;
    },
    orgId() {
      return this.$route.params.organizationId || this.organization?._id;
    },
    organization() {
      return this.$store.getters['organization/selectedItem'];
    },
    orgLogo() {
      // Check logoUrl first (string), then logo (object)
      const logo = this.organization?.logoUrl || this.organization?.logo;
      if (!logo) return '';
      
      // Handle direct URL strings (like organization logos)
      if (typeof logo === 'string') {
        // Process the URL to ensure uploads/ prefix and https:// protocol
        if (logo.includes('megaphonecs.s3.amazonaws.com') || logo.includes('images.megaphon.co.il')) {
          let processedUrl = logo;
          // Convert S3 URLs to CloudFront URLs
          if (logo.includes('megaphonecs.s3.amazonaws.com')) {
            processedUrl = logo.replace('megaphonecs.s3.amazonaws.com', 'images.megaphon.co.il');
          }
          // Ensure uploads/ prefix (but not for /static/ paths)
          if (processedUrl.includes('images.megaphon.co.il/') && 
              !processedUrl.includes('images.megaphon.co.il/uploads/') && 
              !processedUrl.includes('images.megaphon.co.il/static/')) {
            processedUrl = processedUrl.replace('images.megaphon.co.il/', 'images.megaphon.co.il/uploads/');
          }
          // Ensure https:// protocol
          if (!processedUrl.startsWith('http')) {
            processedUrl = `https://${processedUrl}`;
          }
          return processedUrl;
        }
        // If it's already a valid URL string, return it as-is
        if (logo.startsWith('http://') || logo.startsWith('https://')) {
          return logo;
        }
        return logo;
      }
      
      // Handle file objects
      return fixFileSrcToThumbnail(logo, this.organization);
    },
    logoImgSrc() {
      const megaphonLogo = this.$store.getters.envManagement?.logo || require('@/apps/megaphonApp/assets/images/Megaphon_logo_v.png');
      return ((this.orgId == '-1')? megaphonLogo : this.orgLogo) || megaphonLogo;
    },
    loggedUser() {
      return this.$store.getters['auth/loggedUser'];
    },
    filteredRoutesByRoles() {
      const OrgInUser = this.loggedUser?.organizations.find(c => c._id === this.organization?._id);
      if (!OrgInUser) return [];
      return this.organization?.routes
        ?.filter(c => !c.htmlContentFilePath)
        .filter(c => !((c.showInRoles.length === 1) && c.showInRoles[0] === 'client'))
        .filter(c => c.showInRoles.find(role => OrgInUser.roles?.includes(role))) || [];
    },
    showNavContent() {
      return true || ((this.$route.name === 'ReleasePage') && this.organization);
    },
    isOrgProducer() {
      return organizationService.isUserRoleInOrg(this.organization?._id, 'producer', this.loggedUser);
    },
    isUserWatchOnly() {
      return this.$store.getters['auth/isWatchOnly'];
    },
    selectedTheme() {
      return this.$store.getters['selectedTheme'];
    },

    organizationsToSelect() {
      return [
        ...(this.getOnlyOrgsToShow(this.$store.getters['organization/items'], appConfig)?.map(c => ({
          img: fixFileSrcToThumbnail(c.logo, c),
          label: c.name + (this.isOrgPending(c._id)? ` (${this.$t('pending')})` : ''),
          value: c._id,
          disabled: this.isOrgPending(c._id)
        })) || [])
        // ,
        // { label: 'new', value: 'new' }
      ];
    },

    searchIconHtml() {
      return getGlobalSvgs('currentColor').searchFill
    },
    plusIconHtml() {
      const clr = this.selectedTheme?.colors?.[4] || '#ff1235'
      return getGlobalSvgs(clr).plus
    },


    headerMode() {
      if (this.$route.name === 'ReleaseEdit') return 'ReleaseEdit';
      if (this.$route.name === 'ReleaseDistribution') return 'ReleaseDistribution';
      return 'default';
    },
    megSvgs() {
      return getSvgs();
    }
  },
  methods: {
    // emitDefaultFilter() {
    //   if (!this.organization) return;
    //   const firstFilter = this.organization.routes?.[0];
    //   // if (!firstFilter) return;
    //   // this.selecterOrgFilterId = firstFilter?._id || null;
    //   this.emitFilter(firstFilter);
    // },
    // emitFilter(filter = null) {
    //   evManager.emit('org-release-filter', filter);
    //   this.selecterOrgFilterId = filter?.id || null;
    // }
    getOnlyOrgsToShow: organizationService.getOnlyOrgsToShow,
    setOrg(orgId) {
      if (orgId === 'new') this.$router.push({name: 'JoinOrgPage'});
      else if (orgId) this.$router.push({ name: 'ReleasePage', params: { organizationId: orgId } });
    },

    isOrgPending(orgId) {
      return organizationService.isOrgPending(orgId, this.loggedUser);
    },

    async logout() {
      await this.$store.dispatch('auth/logout');
      this.$router.push({ name: 'LoginPage' });
    },
    onSearchSubmit() {
      this.evManager.emit('searchReleases', this.searchTerm)
      this.evManager.emit('search', this.searchTerm)
    },
    clearSearch() {
      this.searchTerm = ''
      this.evManager.emit('searchReleases', this.searchTerm)
    }
  },
  watch: {
    logoImgSrc() { // for some reason sometimes th logo dont change, this watch makes sure the right logo appeares;;
      this.showLogo = false;
      this.$forceUpdate();
      setTimeout(() => {
        this.showLogo = true;
      }, 0);
    },
    // 'organization._id'(val) {
    //   this.selectedOrgId = val;
    // },
    '$route.params.organizationId'(val) {
      if (val) this.selectedOrgId = val;
      this.searchTerm = '';
      // evManager.emit('searchReleases', this.searchTerm)
    }
    // organization: {
    //   deep: true,
    //   handler(val) {
    //     this.emitDefaultFilter(val);
    //   }
    // }
  },
  components: { Avatar, LoggedUserPreview, FormInput, NavOrBurger }
}
</script>

<style lang="scss">
@import '@/assets/styles/global/index';

.megaphon-app {
  .app-header {
    z-index: 6;
    position: fixed;
    top: 0;
    inset-inline: 0;
    // padding: 0 em(10px);
    // background-color: #F2F2F2;
    // color: black;
    // position: relative;
  
    .header-content {
      width: 100%;
      position: relative;
      @media (min-width: $small-screen-break) {
        padding-inline-start: 0;
        gap: 10px;
      }
    }

    .header-search-wrap {
      box-sizing: border-box;
      flex: 1 1 0;              // allow real shrinking with the row
      width: 100%;
      max-width: rem(309px);    // cap at Figma width
      min-width: rem(140px);    // can shrink down to ~140px before collapse
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
    .header-search-form {
      box-sizing: border-box;
      width: 100%;
      max-width: 100%;
      min-width: 0;
      flex: 0 0 auto;
    }
    .header-search-box {
      display: flex;
      align-items: center;
      width: 100%;
      min-width: 0;
      height: 36px;
      box-sizing: border-box;
      // Use brand surface + subtle border instead of fixed white,
      // so it looks correct in both light and dark org themes.
      background-color: var(--clr-1);
      border-radius: 5px;
      border: 1px solid color-mix(in srgb, var(--clr-0) 15%, transparent);
      padding: 0 12px;
      gap: 10px;
    }
    .header-search-icon {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;
      color: var(--clr-4);
      ::v-deep svg {
        width: 18px;
        height: 18px;
        display: block;
      }
    }
    .header-search-input {
      flex: 1;
      min-width: 0;
      height: 100%;
      border: none;
      background: transparent;
      font-size: 16px;
      font-weight: 400;
      line-height: normal;
      color: var(--clr-0);
      outline: none;
      text-align: right;
      direction: rtl;
      &::placeholder {
        color: color-mix(in srgb, var(--clr-0) 50%, transparent);
        opacity: 1;
      }
    }
    .header-search-clear {
      flex-shrink: 0;
      width: 20px;
      height: 20px;
      border: none;
      background: transparent;
      color: #ababab;
      font-size: 16px;
      line-height: 1;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      &:hover {
        color: #4d4d4d;
      }
    }
    
  
    .logo-title { // .logo-title, 
      // height: em(50px);
      height: 100%;
      width: rem(200px);
      margin-inline-end: rem(15px);
      padding: em(5px);
      &.centered-logo {
        justify-content: center;
        background-color: #fff;
      }
      .actual {
        height: 100%;
        width: unset;
        max-width: 100%;
        object-fit: contain;
      }
    }

    .create-nav-link {
      text-decoration: none;
      display: flex;
      align-items: center;
      height: 100%;
      .create-nav-link-inner {
        display: inline-flex;
        align-items: center;
        gap: em(6px);
        font-size: 18px;
        font-weight: 600;
        // Use the same text color as other header nav items
        color: var(--clr-0);
        line-height: 1;
      }
      .create-nav-plus {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: rem(18px);
        height: rem(18px);
        flex-shrink: 0;
        ::v-deep svg {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      &:hover .create-nav-link-inner {
        color: #262626;
      }
    }
    
    .release-actions {
      .nav-items.flex-1 {
        min-width: 0;
      }

      .create-links {
        font-size: em(18px);
      }

      .filters {
        // Tabs can wrap within their area so header stays one row; nav size responds instead of search collapsing
        flex: 0 1 auto;
        min-width: 0;
        flex-wrap: wrap;
        align-content: center;
        row-gap: rem(2px);
        font-size: 16px;
        font-weight: 600;
        gap: 0;
        > *,
        .nav-item {
          position: relative;
          padding: em(10px) em(12px);
          // Match header nav text color with other nav items
          color: var(--clr-0);
          text-decoration: none;
          transition: color 0.15s ease;
          &::after {
            content: '';
            position: absolute;
            left: em(8px);
            right: em(8px);
            top: 0;
            height: 0;
            // Use brand accent for active/hover underline instead of fixed red
            background-color: var(--clr-4);
            transition: height 0.12s ease;
          }
          &:hover::after,
          &.selected::after {
            height: 8px;
          }
          &.selected {
            font-weight: 600;
          }
        }
      }

      // Responsive sizing for left (tabs) and right (create) areas — search keeps its width band
      @media (max-width: 1500px) and (min-width: $small-screen-break) {
        .create-links .create-nav-link-inner {
          font-size: 16px;
        }
        .create-links .create-nav-link {
          gap: em(4px);
        }
        .filters {
          font-size: 15px;
        }
        .filters > *,
        .filters .nav-item {
          padding-inline: em(8px);
        }
        .nav-items.flex-1 {
          column-gap: 20px;
        }
      }

      @media (max-width: 1350px) and (min-width: $small-screen-break) {
        .create-links .create-nav-link-inner {
          font-size: 15px;
        }
        .create-links .create-nav-link {
          gap: em(3px);
        }
        .filters {
          font-size: 14px;
        }
        .filters > *,
        .filters .nav-item {
          padding: em(6px) em(6px);
        }
        .nav-items.flex-1 {
          column-gap: 16px;
        }
      }

      @media (max-width: 1250px) and (min-width: $small-screen-break) {
        .create-links .create-nav-link-inner {
          font-size: 14px;
        }
        .filters {
          font-size: 13px;
        }
        .filters > *,
        .filters .nav-item {
          padding: em(4px) em(5px);
        }
        .nav-items.flex-1 {
          column-gap: 12px;
        }
      }
    }

    .logged-user-preview {
      background-color: unset;
      // Use brand accent for the avatar icon so it looks consistent
      // across light (HOT) and dark (YES) themes.
      --preview-clr: var(--clr-4) !important;
      @media (max-width: $small-screen-break) {
        .actions-section {
          display: none;
        }
      }
    }
    

    @media (max-width: $small-screen-break) { // $small-screen-break
      .nav {
        background-color: white;
      }
      .ph {
        display: none;
      }
    }

    .org-selector {
      padding: 0;
      * {
        background: unset;
        padding: 0;
        width: fit-content;
        border: unset;

      }
      .input {
        // min-width: unset;
        .head {
          flex-direction: row-reverse;
        }
        .selected-preview {
          flex-direction: row-reverse;
          img {
            height: rem(84px);
            width: rem(84px);
            background: unset;
          }
        }
        .drop-down-item {
          width: 100%;
        }
      }
    }
  }

}

</style>